export default "__VITE_ASSET__sOfD8xg9__"